import React, { createContext, useState } from 'react';

const SankeyContext = createContext();

const SankeyProvider = ({ children }) => {
  const [currentNode, setCurrentNode] = useState(null);
  const [currentLink, setCurrentLink] = useState(null);
  const [mosuePosition, setMousePosition] = useState({});
  const [currentActives, setCurrentActives] = useState([]);

  return (
    <SankeyContext.Provider value={{ currentNode, currentLink, setCurrentNode, setCurrentLink, currentActives, setCurrentActives, mosuePosition, setMousePosition }}>
      {children}
    </SankeyContext.Provider>
  );
}

export { SankeyProvider, SankeyContext };